import axios from "axios";

console.log("API URL:", process.env.REACT_APP_API_URL);

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // 🔥 ESTO ES LO QUE FALTABA:
  // Le dice a Axios que está permitido enviar headers protegidos
  // y hace el "apretón de manos" con el credentials: true de tu backend.
  withCredentials: true,
  // Opcional pero muy recomendado para evitar confusiones en el preflight:
  headers: {
    "Content-Type": "application/json",
  }
});

// Interceptor para token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

export default API;